<template>
  <div id="wrapper">
    <b-card class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Detalhes do aviso" :botoes="botoesHeader" breakpoint="md" voltar />
      </template>
      <b-card v-if="aviso" no-body>
        <b-tabs card>
          <b-tab title="Dados gerais do aviso" active>
            <div id="tabDadosGerais">
              <b-row>
                <b-col cols="12" xl="6">
                  <b-col cols="12" class="text-left mb-2">
                    <span><b>Título</b></span>
                    <br />
                    <span class="pos-left">{{ aviso.Titulo }}</span>
                  </b-col>
                  <b-col cols="12" class="text-left mb-2">
                    <span><b>Mensagem</b></span>
                    <br />
                    <span class="pos-left" v-html="aviso.Mensagem"></span>
                  </b-col>
                </b-col>
                <b-col cols="12" xl="6" class="text-left mb-2">
                  <b-table-simple striped>
                    <b-tbody>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">ID</b-td>
                        <b-td class="text-left">{{ aviso.Id }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Situação</b-td>
                        <b-td class="text-left">{{ formatarSituacaoAviso(aviso.Ativo) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Usuário criador</b-td>
                        <b-td class="text-left">{{ capitalize(aviso.UsuarioCadastro) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Usuário última liberação</b-td>
                        <b-td class="text-left">{{ capitalize(aviso.UsuarioLiberacao) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Permite resposta</b-td>
                        <b-td class="text-left">{{ simOuNao(aviso.PermiteResposta) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Data de cadastro</b-td>
                        <b-td class="text-left">{{ formatDataHora(aviso.DataCadastro) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Última alteração</b-td>
                        <b-td class="text-left">{{ formatDataHora(aviso.DataUltAlteracao) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Data de validade</b-td>
                        <b-td class="text-left">{{ formatData(aviso.DataValidade) }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Protocolo/Processo vinculado</b-td>
                        <b-td class="text-left">{{ aviso.Protocolo }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Departamento de origem</b-td>
                        <b-td class="text-left">{{ aviso.Departamento?.Nome }}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td class="font-weight-bold text-right">Tipo de aviso</b-td>
                        <b-td class="text-left">{{ aviso.TipoAviso?.Descricao ?? 'Não informado' }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Anexos">
            <div id="tabAnexos">
              <b-table :busy="isBusy" :fields="anexosFields" hover no-border-collapse :items="anexos"
                :sort-desc="true" striped small show-empty stacked="sm" responsive
                :per-page="anexosPerPage" :current-page="anexosCurrentPage">
                <template #empty>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                  <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div class="actions-icons">
                    <btn-download-component :fazerDownload="baixarAnexo" :parametros="row.item" />
                  </div>
                </template>
              </b-table>
              <table-pagination v-if="anexos.length > anexosPerPage" :total-rows="anexos.length"
                :per-page="anexosPerPage" @pageChange="anexosPageChange" />
            </div>
          </b-tab>
          <b-tab title="Destinatários">
            <div id="tabDestinatarios">
              <b-table :busy="isBusy" :fields="destinatariosFields" hover no-border-collapse :items="destinatarios" 
                :sort-desc="true" striped small show-empty stacked="sm" responsive :per-page="destinatariosPerPage" 
                :current-page="destinatariosCurrentPage">
                <template #empty>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                  <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                  </div>
                </template>
              </b-table>
              <table-pagination v-if="destinatarios.length > destinatariosPerPage" :total-rows="destinatarios.length"
                 :per-page="destinatariosPerPage" @pageChange="destinatariosPageChange" />
            </div>
          </b-tab>
          <b-tab title="Visualizações" lazy>
            <AbaVisualizacoesAviso :idAviso="idAviso" :visualizacoes="visualizacoes" />
          </b-tab>
          <b-tab title="Respostas">
            <b-row class="up-data">
              <b-col cols="12" md="8"></b-col>
              <b-col cols="12" md="4">
                <b-input-group size="md">
                  <b-form-input id="respostas-filter-input" v-model="respostasFilter" type="search"
                    placeholder="Pesquisar"></b-form-input>
                  <b-input-group-append>
                    <b-button @click="respostasFilter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <div id="tabRespostas">
              <b-table :busy="isBusy" :fields="respostasFields" :filter="respostasFilter"
                :filter-included-fields="respostasFilterOn" hover no-border-collapse :items="respostas" 
                :sort-desc="true" striped small show-empty stacked="sm" responsive :per-page="respostasPerPage" 
                :current-page="respostasCurrentPage">
                <template #cell(show_details)="row">
                  <div class="actions-icons">
                    <div class="wrapper-icon" @click="row.toggleDetails">
                      <font-awesome-icon :icon="row.detailsShowing ? 'eye-slash' : 'eye'" />
                    </div>
                  </div>
                </template>
                <template #row-details="row">
                  <b-card>
                    <div class="detalhesResposta">
                      <h6>Mensagem</h6>
                      <span v-html="row.item.mensagem"></span>
                      <div class="mt-2 d-flex flex-column align-items-start" v-if="row.item.Arquivos.length > 0"
                        id="anexosResposta">
                        <h6>Anexos</h6>
                        <ul class="listaAnexos">
                          <li v-for="arquivo in row.item.Arquivos" :key="arquivo.Nome">
                            <div>
                              {{ arquivo.Nome }}
                              <btn-download-component class="ml-2" :texto="''" :fazerDownload="baixarAnexo"
                                :parametros="arquivo" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </b-card>
                </template>
                <template #empty>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                  <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                  <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                  </div>
                </template>
              </b-table>
              <table-pagination v-if="respostas.length > respostasPerPage" :total-rows="respostas.length"
                :per-page="respostasPerPage" @pageChange="respostasPageChange" />
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-card>
    <modal-desativar-aviso v-if="mostrarModalDesativarAviso" :id-aviso="idAviso"
      @fecharModalDesativarAviso="fecharModalDesativarAviso()" />
  </div>
</template>

<script lang="ts">
import messagesService from "@/services/messagesService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import ModalDesativarAviso from "@/views/cadastro-avisos/ModalDesativarAviso.vue";
import BtnDownloadComponent from "@/components/shared/btn-download.vue";
import { UtilsTS } from '@/utilsts';
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import { BotaoSagres } from '@/types/botao-sagres';
import { fieldsDestinatariosDetalhes } from "@/types/avisos/fields-destinatarios";
import { Aviso } from "@/types/avisos/aviso";
import { fieldsRespostas } from "@/types/avisos/fields-respostas";
import { fieldsAnexos } from "@/types/avisos/fields-anexos";
import AbaVisualizacoesAviso from "@/components/avisos/AbaVisualizacoesAviso.vue";

const CompProps = Vue.extend({
  name: 'DetalhesAviso',
  components: {
    AbaVisualizacoesAviso,
    BtnDownloadComponent,
    HeaderSagres,
    ModalDesativarAviso,
    TablePagination,
  },
  props: {
    idAviso: {
      type: String,
      required: true
    }
  }
})
@Component
export default class DetalhesAviso extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 3,
      icone: 'times',
      texto: 'Desativar este aviso',
      acao: () => this.mostrarModalDesativarAviso = true,
    },
    {
      id: 2,
      icone: 'edit',
      texto: 'Editar aviso',
      acao: () => this.$router.push('/avisos/editar/' + this.idAviso),
    },
  ]

  aviso: Aviso | null = null
  destinatarios: any[] = []
  anexos: any[] = []
  visualizacoes: any[] = []
  respostas: any[] = []
  isBusy = true

  destinatariosFields = fieldsDestinatariosDetalhes
  destinatariosPerPage = 10
  destinatariosCurrentPage = 1

  respostasFields = fieldsRespostas
  respostasFilter = ''
  respostasFilterOn = ["nomeUsuario", "unidadeGestora"]
  respostasPerPage = 10
  respostasCurrentPage = 1

  anexosFields = fieldsAnexos
  anexosPerPage = 10
  anexosCurrentPage = 1

  mostrarModalDesativarAviso = false

  destinatariosPageChange(value) {
    this.destinatariosCurrentPage = value;
  }
  respostasPageChange(value) {
    this.respostasCurrentPage = value;
  }
  async getAviso(id) {
    try {
      const avisoResponse = await messagesService.getAviso(id);
      this.aviso = avisoResponse.aviso
      this.destinatarios = avisoResponse.destinatarios
      this.visualizacoes = avisoResponse.visualizacoes
      this.respostas = avisoResponse.respostas
    } finally {
      this.isBusy = false;
    }
  }
  async fecharModalDesativarAviso() {
    this.mostrarModalDesativarAviso = false;
    await this.getAviso(this.idAviso);
  }

  anexosPageChange(value) {
    this.anexosCurrentPage = value;
  }

  async getAnexos(id) {
    this.isBusy = true;
    const response = await messagesService.getAnexosAviso(id);
    if (response && response.status == 200) {
      this.anexos = response.data;
    } else {
      this.$toast.error("Erro ao obter anexos");
    }
    this.isBusy = false;
  }

  async baixarAnexo(arquivo) {
    const response = await messagesService.baixarAnexo(arquivo.Id);
    if (response && response.status == 200)
      this.download(arquivo.Nome, response.data);
    else {
      this.$toast.error("Erro ao baixar o arquivo solicitado.");
    }
  }

  async mounted() {
    await this.getAviso(this.idAviso);
    await this.getAnexos(this.idAviso);
  }
}
</script>

<style>
.detalhesResposta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>